<script>
    import {fade} from 'svelte/transition';
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
    import Mobilebtn2 from '../mobilebtn2.svelte';
    let show = true;
    let text;
    let textClass = 'stroketext';
    let discrip;
    let navbar;
    let opacityBtn = 1;
    setTimeout(()=> {
        show=false;
        text.style.top='46.729vw';
        text.style.opacity = '1';
        textClass='afterStroke';
        discrip.style.color='white';
        navbar.style.zIndex='7';
    }, 8000);
    setTimeout(()=> {
        opacityBtn = 10;
    }, 8500);
    setTimeout(()=> {
        text.style.opacity = '1';
    }, 5800);
</script>
<section>
    {#if show}
    <div class="splashdiv" transition:fade="{{duration: 1090}}">
    </div>
    {/if}
    <div class="navbar" bind:this={navbar}>
        <MobileNavbar />
    </div>
    <div class="maindiv">
        <div class="arrowDown">
            <img src="/images/createmain/arrowDown.svg" alt="" width="100%" height="100%">
        </div>
    </div>
    <div class="btn" style="z-index: {opacityBtn};">
        <Mobilebtn2 bgcolor='#FF9EFF' txtcolor='black' text='Join Storytellers Governace Council'
        width='65.421vw' border='solid #FF9EFF 0.234vw' state ="Storyteller"/>
    </div>
    <div  class="text" bind:this={text}>
        <p class={textClass}>UNLEASH</p>
        <p class={textClass} style="">YOUR</p>
        <div class="imagin">
            <p>IMAGINATION</p>
        </div>
        <div class="discrip" bind:this={discrip} >
            <p style="margin-left: 21.262vw;">& let our <span style="font-weight: 900;">TECHNOLOGY</span> do the work.</p>
            <p style="margin-top: 57.944vw; width: 78.505vw;">We’re building the future where storytellers no longer are a passive wordslinger, rather an active orchestrator interacting with a live 3D canvas which turns your words into a living breathing world in the blink of an eye. 
                <br><br><br>
                Write scenes, characters and their dialogs and watch it happen in real time.</p>
        </div>
        
    </div>
</section>
<style>
    .navbar{
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 4;
    }
    section{
        font-family: 'Orbitron';
        position: relative;
    }
    .splashdiv{
        position: fixed;
        background-color: black;
        width: 100vw;
        height:max(216.355vw, 100.16vh);
        z-index: 5;
    }
    p{
        margin: 0;
    }
    .text{
        position: absolute;
        left: 11.916vw;
        top: max(88.995vw, 41.134vh);
        transition-duration: 1.5s;
        z-index: 6;
        opacity: 0;
    }
    .stroketext{
        font-size: 4.673vw;
        font-weight: 900;
        -webkit-text-stroke: 0.35vw white;
        position: relative;
        z-index: 6;
        letter-spacing: 0.1em;
        line-height: 9vw;
    }
    .stroketext:nth-child(2){
        margin-left: 18.224vw;
    }
    .afterStroke{
        font-weight: 900;
        font-size: 9.346vw;
        letter-spacing: 0.1em;
        transition-duration: 0.5s;
        color: white;
        position: relative;
        z-index: 6;
        line-height: 9vw;
    }
    .afterStroke:nth-child(2){
        margin-left: 31vw;
    }
    .imagin{
        font-weight: 900;
        font-size: 9.346vw;
        letter-spacing: 0.1em;
        color: #FF65FF;
        line-height: 9vw;
    }
    .maindiv{
        position: relative;
        background-image: url('/images/createmain/storyBg.png');
        background-size: cover;
        background-position: center;
        width: 100vw;
        height: max(216.355vw, 100.16vh);
        z-index: 1;
    }
    .discrip{
        font-size: 2.804vw;
        font-weight: 400;
        color: black;
        letter-spacing: 0.06em;
        line-height: 3.925vw;
        transition-duration: 2s;
        text-align: center;
    }
    .arrowDown{
        position: absolute;
        bottom: max(7.009vw, 3.240vh);
        width: 3.505vw;
        height: 3.336vw;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    .btn{
        position: absolute;
        bottom: max(24.766vw, 11.447vh);
        left: 17.290vw;
    }
</style>